import React, { useEffect, useState } from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { useDispatch, useSelector } from "react-redux";
import { loadReportCategoryDataUser } from "./Slice/reportUserSlice";
import { saveForumReportAdmin, clearReportStatus } from "./Slice/reportAdminSlice";
import PropTypes from "prop-types";

const ReportAdmin = (props) => {

  const { userdata} = props;
  const { register, formState: { errors }, handleSubmit } = useForm();
  const [getLoader, setGetLoader] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const dispatch = useDispatch();
  const { categories } = useSelector((state) => state?.reportUser);
  const { success, error } = useSelector((state) => state?.reportAdmin);

  useEffect(() => {
    dispatch(loadReportCategoryDataUser());
  }, [dispatch]);

  useEffect(() => {
    if (success || error) {
      setShowPopup(true);
    }
  }, [success, error]);

  const onSubmit = async (data) => {
    setGetLoader(true);
    const payload = {
      user_id: userdata.user_id,
      ques_id: userdata.ques_id,
      ans_id: userdata.ans_id,
      report_type: userdata.report_type,
      category: data.category,
      description: data.description,
    };

    dispatch(saveForumReportAdmin(payload));
    setGetLoader(false);
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered className="calendar-modal"
      >
        <Modal.Header closeButton>
          <h3>
            <b>Report to Admin</b>
          </h3>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="mentor_detail align-items-center">
              <Col sm={12}>
                <div className="form-group">
                  <label className="form-label" htmlFor="category">Category</label>
                  <Form.Control
                    as="select"
                    className="mb-3"
                    name="category"
                    {...register("category", { required: true })}
                  >
                    <option value="" key="">
                      Select Option
                    </option>

                    {/* {categories && */}
                      {categories.map((item) => (
                        <option value={item.id} key={item.id}>
                          {item.name}
                        </option>
                      ))}
                  </Form.Control>
                  {errors.category && errors.category?.type === "required" && (
                    <label className="customeValidationText text-left" htmlFor="category">
                      Please select category
                    </label>
                  )}
                </div>
              </Col>
              <Col sm={12}>
                <label className="form-label" htmlFor="description">Reason (Optional)</label>
                <Form.Control
                  as="textarea"
                  className={"form-control"}
                  name="description"
                  defaultValue=""
                  aria-invalid={"false"}
                  {...register("description", { maxLength: 6000 })}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <div className="form-group mt-3 text-left">
                  <Button
                    className="btn nextbtn ml-2"
                    type="submit"
                    disabled={getLoader}
                  >
                    {getLoader ? "Submitting..." : "Submit"}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
      <PopupModalWithOk
        show={showPopup}
        onHide={() => {
          setShowPopup(false);
          dispatch(clearReportStatus());
        }}
        message={success || error}
        showConfirm={false}
        staticBackdrop={true}
      />

    </>
  );
};

ReportAdmin.propTypes = {
  userdata: PropTypes.shape({
    user_id: PropTypes.number,
    ques_id: PropTypes.number,
    ans_id: PropTypes.number,
    report_type: PropTypes.string,
  }).isRequired,
};

export default ReportAdmin;
